import React, { useState, useEffect } from "react";
import DoctorUI from "../components/doctorUI/DoctorUI";
import PatientUI from "../components/patientUI/PatientUI";

function Home() {
  const [isDoctor, setIsDoctor] = useState();

  useEffect(() => {
    const interval = setInterval(() => {
      if (localStorage.getItem("claim") === "doctor") {
        setIsDoctor(true);
      } else {
        setIsDoctor(false);
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);

  console.log(window.location.href);

  return (
    <div> {isDoctor ? <DoctorUI> </DoctorUI> : <PatientUI></PatientUI>} </div>
  );
}

export default Home;
